import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";

import config from "../config";
import { action, makeObservable, observable } from "mobx";

class SpeedGraphStore {
    speedGraph = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
        speedGraph: observable,
      total: observable,
      loading: observable,
      loadSpeedGraphData: action,
    });
    this.rootStore = rootStore;
  }

  async loadSpeedGraphData({
    offset,
    limit,
    companyId,
    vehicleId,
    fromDate,
    toDate,
    Date,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      isGraph: 1,
      offset: 0,
      limit: 15,
      page: 1,
    };

    if(config.pythonReport === 1){
        // postData.companyId=10166
        // postData.vehicleId=27043
        var response = await postApi.getClient('report').post("/alert_report/speed-violation", postData);
        var speedvstime = response?.data?.data?.speedexception;
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        response = await postApi.getClient().post("index.php?c=vehicle&a=speedvstime", "postData=" + base64Input);
        speedvstime = response?.data?.data?.speedvstime;
    }
   
    // console.log("fuel", response?.data?.data?.speedvstime);
    var speedGraphData = speedvstime;
    if (speedGraphData && speedGraphData) {
        speedGraphData.forEach((element) => {
        element.speed = parseFloat(element.speed);
      });
    }
    this.speedGraph = speedvstime;

    // this.distanceGraph = response?.data?.data?.distancegraph;
    return speedvstime;
  }
}

export default SpeedGraphStore;
